/**
 * Sidebar Utilities
 *
 * Funciones puras para procesamiento de navegación
 */

import { NavigationItem, Context } from '../types/sidebar.types';

/**
 * Obtener label apropiado según el contexto
 */
export const getItemLabel = (item: NavigationItem, context: Context): string => {
  if (context.type === 'global' && item.globalLabel) {
    return item.globalLabel;
  }
  if (context.type === 'project' && item.projectLabel) {
    return item.projectLabel;
  }
  return item.label;
};

/**
 * Obtener href del item (sin modificación de contexto por ahora)
 */
export const getItemHref = (item: NavigationItem): string => {
  return item.href;
};

/**
 * Check if a path matches a pattern (supports * wildcard)
 */
const matchesPattern = (path: string, pattern: string): boolean => {
  // Remove query params from both path and pattern for comparison
  const cleanPath = path.split('?')[0];
  const cleanPattern = pattern.split('?')[0];

  // Handle wildcard patterns like /pipelines/*
  if (cleanPattern.endsWith('/*')) {
    const basePath = cleanPattern.slice(0, -2); // Remove /*
    // Only match sub-paths, not the base path itself
    // e.g., /pipelines/* matches /pipelines/active but NOT /pipelines
    return cleanPath.startsWith(basePath + '/');
  }

  // Exact match only (use matchPaths with wildcards for sub-path matching)
  return cleanPath === cleanPattern;
};

/**
 * Verificar si un path actual coincide con el href del item o sus matchPaths
 */
export const isItemActive = (currentPath: string, itemHref: string, matchPaths?: string[]): boolean => {
  // Remove leading slash if present for consistency
  const normalizedHref = itemHref.startsWith('/') ? itemHref : `/${itemHref}`;

  // Check main href
  if (matchesPattern(currentPath, normalizedHref)) {
    return true;
  }

  // Check additional match paths
  if (matchPaths && matchPaths.length > 0) {
    return matchPaths.some(pattern => matchesPattern(currentPath, pattern));
  }

  return false;
};

/**
 * Normalizar path para navegación (asegurar que comience con /)
 */
export const normalizePath = (href: string): string => {
  return href.startsWith('/') ? href : `/${href}`;
};
